module.exports = __webpack_public_path__ + "img/save-icon.772a4d3c.svg";